import { StackedBarchartModule } from '../stacked-bar-chart/stackedbarchart.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { GanttChartWidget } from './component/gantt-chart/gantt-chart.component';
import { StationGroupComponent } from './component/station-group/station-group.component';
import { CommonLayoutModule } from '@sdbn/common';
import { TransportRowComponent } from './component/transport-row/transport-row.component';

import { TransportItemComponent } from './component/transport-item/transport-item.component';
import { GanttScaleComponent } from './component/gantt-scale/gantt-scale.component';
import { GanttLinesComponent } from './component/gantt-lines/gantt-lines.component';
import { GanttLegendComponent } from './component/gantt-legend/gantt-legend.component';
import { StructureNodeSelectionModule } from 'src/tmc-yard/components/structure-node-selection/structure-node-selection.module';

@NgModule({
  imports: [
    CommonModule,
    CommonUIModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
    StackedBarchartModule,
    CommonTranslationModule,
    CommonLayoutModule,
    StructureNodeSelectionModule
  ],
  declarations: [
    GanttChartWidget,
    StationGroupComponent,
    TransportRowComponent,
    TransportItemComponent,
    GanttScaleComponent,
    GanttLinesComponent,
    GanttLegendComponent
  ]
})
export class GanttChartModule { }
